/// <reference path="../../typings/tsd.d.ts" /> 
interface Array<T> {
    remove(o: T): Array<T>;
    addRange(o: Array<T>): Array<T>;
}

interface String {
    isEmptyOrSpaces(): boolean;
    startsWith(string): boolean;
}

//interface Object {
//    getType():string;
//}
Array.prototype.remove = function (o) {
    var what, a = arguments, L = a.length, ax;
    while (L && this.length) {
        what = a[--L];
        while ((ax = this.indexOf(what)) !== -1) {
            this.splice(ax, 1);
        }
    }
    return this;
}

Array.prototype.addRange = function (arrayToAdd) {
    if (!arrayToAdd) return this;
    for (var i = 0; i < arrayToAdd.length; i++) {
        this.push(arrayToAdd[i]);
    }

    return true;
}

String.prototype.isEmptyOrSpaces = function (): boolean {
    return this.match(/^\s*$/) !== null;
}

//Object.prototype.getType = function ():string {
//    var funcNameRegex = /function (.{1,})\(/;
//    var results = (funcNameRegex).exec((this).constructor.toString());
//    return (results && results.length > 1) ? results[1] : "";
//};